import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite } from "pixi.js";
export class WheelPointer extends View {
    private sprite: Sprite;
    private maxAlpha: number;

    constructor(services: GameServices) {
        super(services);

        const {factory, resources} = this.services;

        const spec = resources.getSpec(`wheel`).slices.wheelPointer;
        factory.applySpec(this, spec);

        this.sprite = factory.createSprite(spec.glow, this);
        this.maxAlpha = spec.glow.maxAlpha;
        this.sprite.alpha = 0;
    }

    turnOn(): void {
        this.sprite.alpha = this.maxAlpha;
    }

    turnOff(): void {
        this.sprite.alpha = 0;
    }

    setBrightness(brightness: number): void {
        this.sprite.alpha = brightness * this.maxAlpha;
    }

    override reset(): void {
        this.turnOff();
    }
}